import { api } from '@culture/common-helpers/request';

import { systemMessageActions } from '../systemMessage';
import * as types from './types';

export const entitySubscribe = (data) => (dispatch) => {
	dispatch({
		type: types.PERSONALIZATIONS_ENTITY_SUBSCRIBE_START
	});

	const promise = api('personalizations/entity/subscribe', data, 'POST');

	promise.then(
		(response) => {
			dispatch({
				type: types.PERSONALIZATIONS_ENTITY_SUBSCRIBE_SUCCESS,
				payload: response
			});
		},
		(err) => {
			dispatch({
				type: types.PERSONALIZATIONS_ENTITY_SUBSCRIBE_ERROR,
				payload: err
			});
		}
	);

	return promise;
};

export const entityUnsubscribe = (data) => (dispatch) => {
	dispatch({
		type: types.PERSONALIZATIONS_ENTITY_UNSUBSCRIBE_START
	});

	const promise = api('personalizations/entity/unsubscribe', data, 'POST');

	promise.then(
		(response) => {
			dispatch({
				type: types.PERSONALIZATIONS_ENTITY_UNSUBSCRIBE_SUCCESS,
				payload: response
			});
		},
		(err) => {
			dispatch({
				type: types.PERSONALIZATIONS_ENTITY_UNSUBSCRIBE_ERROR,
				payload: err
			});
		}
	);

	return promise;
};

export const thematicSubscribe = (data) => (dispatch) => {
	dispatch({
		type: types.PERSONALIZATIONS_THEMATIC_SUBSCRIBE_START
	});

	const promise = api('personalizations/thematic/subscribe', data, 'POST');

	promise.then(
		(response) => {
			dispatch({
				type: types.PERSONALIZATIONS_THEMATIC_SUBSCRIBE_SUCCESS,
				payload: response
			});
		},
		(err) => {
			dispatch({
				type: types.PERSONALIZATIONS_THEMATIC_SUBSCRIBE_ERROR,
				payload: err
			});
		}
	);

	return promise;
};

export const thematicUnsubscribe = (data) => (dispatch) => {
	dispatch({
		type: types.PERSONALIZATIONS_THEMATIC_UNSUBSCRIBE_START
	});

	const promise = api('personalizations/thematic/unsubscribe', data, 'POST');

	promise.then(
		(response) => {
			dispatch({
				type: types.PERSONALIZATIONS_THEMATIC_UNSUBSCRIBE_SUCCESS,
				payload: response
			});
		},
		(err) => {
			dispatch({
				type: types.PERSONALIZATIONS_THEMATIC_UNSUBSCRIBE_ERROR,
				payload: err
			});

			dispatch(systemMessageActions.createMessage(err.userMessage));
		}
	);

	return promise;
};

export const getMe = () => (dispatch) => {
	dispatch({
		type: types.PERSONALIZATIONS_GET_ME_START
	});

	const promise = api('personalizations/me', {}, 'GET');

	promise.then(
		(response) => {
			dispatch({
				type: types.PERSONALIZATIONS_GET_ME_SUCCESS,
				payload: response
			});
		},
		(err) => {
			dispatch({
				type: types.PERSONALIZATIONS_GET_ME_ERROR,
				payload: err
			});

			dispatch(systemMessageActions.createMessage(err.userMessage));
		}
	);

	return promise;
};
